<template>
  <v-ons-page id="settings-page">
    <v-ons-toolbar>
      <div class="center">設定</div>
    </v-ons-toolbar>
    <v-ons-list class="setting-list">
      <v-ons-list-header>再読み込み</v-ons-list-header>
      <v-ons-list-item class="list-item-button">
        <v-ons-button modifier="quiet large" @click="reload()">再読み込み</v-ons-button>
      </v-ons-list-item>
      <v-ons-list-item class="list-item-button">
        <v-ons-button modifier="quiet large" @click="reload(true)">キャッシュを削除して再読み込み</v-ons-button>
      </v-ons-list-item>
    </v-ons-list>
    <v-ons-list class="setting-list">
      <v-ons-list-header>起動時に表示するタブ</v-ons-list-header>
      <v-ons-list-item v-for="(tab, $index) in tabs" :key="tab" tappable>
        <label class="left">
          <v-ons-radio :input-id="'radio-' + $index" :value="tab" v-model="settings.initial_tab"></v-ons-radio>
        </label>
        <label :for="'radio-' + $index" class="center">
          {{tab}}
        </label>
      </v-ons-list-item>
    </v-ons-list>
    <v-ons-list class="setting-list">
      <v-ons-list-header>データの同期 (未実装)</v-ons-list-header>
      <v-ons-list-item class="list-item-button" v-if="!is_authed">
        <v-ons-button modifier="quiet large" @click="login">Googleアカウントでログイン</v-ons-button>
      </v-ons-list-item>
      <v-ons-list-item class="list-item-button" v-if="is_authed">
        <v-ons-button modifier="quiet large" @click="logout">ログアウト</v-ons-button>
      </v-ons-list-item>
    </v-ons-list>
    <v-ons-list class="setting-list">
      <v-ons-list-header>その他</v-ons-list-header>
      <v-ons-list-item>
        <label :for="'dark-mode'">ダークモード (未実装)</label>
        <div class="right"><v-ons-switch input-id="dark-mode" v-model="settings.dark_mode"></v-ons-switch></div>
      </v-ons-list-item>
    </v-ons-list>
  </v-ons-page>
</template>

<script>
  export default {
    name: 'settings-page',
    data () {
      return {
        is_authed: false,
        tabs: ['チュートリアル', 'HS計算', '楽曲リスト', '設定'],
        settings: {
          initial_tab: 'チュートリアル',
          dark_mode: false
        }
      }
    },
    methods: {
      reload: function (forceReload = false) {
        if (forceReload) {
          window.dispatchEvent(new Event('clearCache'))
        }
        location.reload(forceReload)
      },
      login: function () {
      },
      logout: function () {
      }
    },
    mounted: function () {
      let settings = JSON.parse(localStorage.getItem('settings'))
      if (settings) {
        this.settings = settings
      }
    },
    updated: function () {
      localStorage.setItem('settings', JSON.stringify(this.settings))
    }
  }
</script>

<style>
  .setting-list {
    margin-top: 30px !important;
  }

  .setting-list:last-child {
    margin-bottom: 30px !important;
  }

  .page--material .setting-list {
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
  }

  .list-item-button > div {
    padding: 0;
  }

  .ios .list-item-button ons-button:active {
    background-color: lightslategray;
  }
</style>



// WEBPACK FOOTER //
// src/components/SettingsPage.vue